export default __webpack_public_path__ + "static/media/MINGLIU.cd8446fc.ttf";